/*******************************************************************************
Hides Ad Containers When Ads Have Been Shut Off
*******************************************************************************/

export default function hideAdContainers() {
    const numAdsInHeader = $('.site-header').data('num-ads');
    if (numAdsInHeader !== 'off') { return; }


    // Hide the ad containers
    const adContainerClasses = ['ad', 'ad-standard', 'ad-footer', 'ad-article', 'ad-tall__sidebar', 'ad-container-side', 'ad-container-side-lg', 'in-article-text-ad'];
    $.each(adContainerClasses, (i, adClass) => { $(`.${adClass}`).remove(); });

    // If the "plp" parameter exists, remove the ad containers and the plp parameter from the URL
    const params = new URLSearchParams(location.search);

    // Remove the "plp" parameter from the URL if it exists
    if (params.get('plp')) {
        params.delete('plp');
        const paramsLength = Array.from(params).length;
        const qMark = (paramsLength !== 0) ? '?' : '';
        window.history.replaceState({}, '', `${location.pathname}${qMark}${params}`);
    }
}
